import axios from 'axios'
import dbPromise from '../../dbPromise'
export default ({
  state: {
    timesheet: []
  },
  mutations: {
    setTimesheetData (state, payload) {
      state.timesheet = payload
    }
  },
  actions: {
    fetchTimesheet ({ commit, getters }) {
      commit('setLoading', true)
      axios.post(getters.url + `/tanda-service/getShiftsForEmp.ajax.php`, {
        emp: getters.user.empID,
        company: getters.company
      })
        .then(response => {
          commit('setLoading', false)
          let data = response.data
          commit('setTimesheetData', data)
          dbPromise().then((db) => {
            let tx = db.transaction('timesheet-archive', 'readwrite')
            let timesheetStore = tx.objectStore('timesheet-archive')
            timesheetStore.put(data, getters.user.empID)
            return tx.complete
          }).then(() => {
            console.log('data saved locally')
          })
        }).catch((e) => {
          dbPromise().then((db) => {
            let tx = db.transaction('timesheet-archive')
            let timesheetStore = tx.objectStore('timesheet-archive')
            return (timesheetStore.get(getters.user.empID))
          }).then((val) => {
            commit('setLoading', false)
            if (val !== undefined) {
              commit('setTimesheetData', val)
            }
          })
        })
    }
  },
  getters: {
    timesheet (state) {
      return state.timesheet
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/timesheet/index.js